import { createRequestTypes } from "../utils";


export const LOGOUT = createRequestTypes("LOGOUT");

export const logoutRequest = () => ({ type: LOGOUT.REQUEST });
export const logoutSuccess = (empty) => ({ type: LOGOUT.SUCCESS, payload: { empty } });
export const logoutFailure = (error) => ({ type: LOGOUT.FAILURE, payload: error });

// Other Actions
export const CHECK_AUTHORIZATION = 'CHECK_AUTHORIZATION';
export const checkAuthorization = () => ({ type: CHECK_AUTHORIZATION });

export const INITIALIZE = createRequestTypes("INITIALIZE");
export const initialize = () => ({ type: INITIALIZE.REQUEST });

export const RESET_SESSION_ID = createRequestTypes("RESET_SESSION_ID");
export const resetSessionId = () => ({ type: RESET_SESSION_ID.REQUEST });


export const SET_USER = createRequestTypes("SET_USER");
export const setUser = (user = {}) => ({ type: SET_USER.REQUEST, payload: { user } });


export const FETCH_SPOREUSER = createRequestTypes("FETCH_SPOREUSER");
export const fetchSporeUser = (sporeuser) => ({ type: FETCH_SPOREUSER.REQUEST, payload: { sporeuser } });
export const fetchSporeUserSuccess = (sporeuser) => ({ type: FETCH_SPOREUSER.SUCCESS, payload: { sporeuser } });
export const fetchSporeUserFailure = (errorAuth) => ({ type: FETCH_SPOREUSER.FAILURE, payload: { errorAuth } });

export const FETCH_ADDRESSES = createRequestTypes("FETCH_ADDRESSES");
export const fetchAddress = () => ({ type: FETCH_ADDRESSES.REQUEST, payload: {} });
export const fetchAddressSuccess = (addresses) => ({ type: FETCH_ADDRESSES.SUCCESS, payload: { addresses } });
export const fetchAddressFailure = (errorAuth) => ({ type: FETCH_ADDRESSES.FAILURE, payload: { errorAuth } });

export const SET_USER_ADDRESS = createRequestTypes("SET_USER_ADDRESS");
export const setAddressRequest = (recipient, phone, addressType, address, city, state, country, zipcode, isDefault) =>
    ({ type: SET_USER_ADDRESS.REQUEST, payload: { recipient, phone, addressType, address, city, state, country, zipcode, isDefault } });
export const setAddressSuccess = (addresses) =>
    ({ type: SET_USER_ADDRESS.SUCCESS, payload: { addresses } });
export const setAddressFailure = (error) =>
    ({ type: SET_USER_ADDRESS.Failure, payload: { error } });

export const DELETE_USER_ADDRESS = createRequestTypes("DELETE_USER_ADDRESS");
export const deleteAddressRequest = (id) => ({ type: DELETE_USER_ADDRESS.REQUEST, payload: { id } });
export const deleteAddressSuccess = (addresses) => ({ type: DELETE_USER_ADDRESS.SUCCESS, payload: { addresses } });
export const deleteAddressFailure = (error) => ({ type: DELETE_USER_ADDRESS.FAILURE, payload: { error } });

export const UPDATE_TOUR = createRequestTypes("UPDATE_TOUR");
export const updateTour = (name, value) => ({ type: UPDATE_TOUR.REQUEST, payload: { name, value } });

// Update Sporeuser
export const UPDATE_SPOREUSER = createRequestTypes("UPDATE_SPOREUSER");

export const updateSporeUserRequest = (data) => ({ type: UPDATE_SPOREUSER.REQUEST, payload: { data } });
export const updateSporeUserSuccess = (sporeuser) => ({ type: UPDATE_SPOREUSER.SUCCESS, payload: { sporeuser } });
export const updateSporeUserFailure = (error) => ({ type: UPDATE_SPOREUSER.FAILURE, payload: { error } });

// Update social
export const UPDATE_SPOREUSER_SOCIAL = createRequestTypes("UPDATE_SPOREUSER_SOCIAL");

export const updateSporeUserSocialRequest = (socials) => ({ type: UPDATE_SPOREUSER_SOCIAL.REQUEST, payload: { socials } });
export const updateSporeUserSocialRequestSuccess = (social) => ({ type: UPDATE_SPOREUSER_SOCIAL.SUCCESS, payload: { social } });
export const updateSporeUserSocialRequestFailure = (error) => ({ type: UPDATE_SPOREUSER_SOCIAL.FAILURE, payload: { error } });

// Update password
export const UPDATE_SPOREUSER_PASSWORD = createRequestTypes("UPDATE_SPOREUSER_PASSWORD");

export const updateSporeUserPasswordRequest = (password) => ({ type: UPDATE_SPOREUSER_PASSWORD.REQUEST, payload: { password } });
export const updateSporeUserPasswordSuccess = () => ({ type: UPDATE_SPOREUSER_PASSWORD.SUCCESS });
export const updateSporeUserPasswordFailure = (error) => ({ type: UPDATE_SPOREUSER_PASSWORD.FAILURE, payload: { error } });

// Add specialty
export const ADD_SPOREUSER_SPECIALTY = createRequestTypes("ADD_SPOREUSER_SPECIALTY");

export const addSporeUserSpecialtyRequest = (specialty) => ({ type: ADD_SPOREUSER_SPECIALTY.REQUEST, payload: { specialty } });
export const addSporeUserSpecialtySuccess = () => ({ type: ADD_SPOREUSER_SPECIALTY.SUCCESS });
export const addSporeUserSpecialtyFailure = (error) => ({ type: ADD_SPOREUSER_SPECIALTY.FAILURE, payload: { error } });

// Remove specialty
export const REMOVE_SPOREUSER_SPECIALTY = createRequestTypes("REMOVE_SPOREUSER_SPECIALTY");

export const removeSporeUserSpecialtyRequest = (id) => ({ type: REMOVE_SPOREUSER_SPECIALTY.REQUEST, payload: { id } });
export const removeSporeUserSpecialtySuccess = () => ({ type: REMOVE_SPOREUSER_SPECIALTY.SUCCESS });
export const removeSporeUserSpecialtyFailure = (error) => ({ type: REMOVE_SPOREUSER_SPECIALTY.FAILURE, payload: { error } });


// Add Subspecialty
export const ADD_SPOREUSER_SUBSPECIALTY = createRequestTypes("ADD_SPOREUSER_SUBSPECIALTY");

export const addSporeUserSubSpecialtyRequest = (specialty) => ({ type: ADD_SPOREUSER_SUBSPECIALTY.REQUEST, payload: { specialty } });
export const addSporeUserSubSpecialtySuccess = () => ({ type: ADD_SPOREUSER_SUBSPECIALTY.SUCCESS });
export const addSporeUserSubSpecialtyFailure = (error) => ({ type: ADD_SPOREUSER_SUBSPECIALTY.FAILURE, payload: error });

// Remove subspecialty
export const REMOVE_SPOREUSER_SUBSPECIALTY = createRequestTypes("REMOVE_SPOREUSER_SUBSPECIALTY");

export const removeSporeUserSubSpecialtyRequest = (id) => ({ type: REMOVE_SPOREUSER_SUBSPECIALTY.REQUEST, payload: { id } });
export const removeSporeUserSubSpecialtySuccess = () => ({ type: REMOVE_SPOREUSER_SUBSPECIALTY.SUCCESS });
export const removeSporeUserSubSpecialtyFailure = (error) => ({ type: REMOVE_SPOREUSER_SUBSPECIALTY.FAILURE, payload: error });




// Add image
export const ADD_SPOREUSER_IMAGE = createRequestTypes("ADD_SPOREUSER_IMAGE");

export const addSporeUserImageRequest = (image, location) => ({ type: ADD_SPOREUSER_IMAGE.REQUEST, payload: { image, location } });
export const addSporeUserImageSuccess = (sporeuser) => ({ type: ADD_SPOREUSER_IMAGE.SUCCESS, payload: { sporeuser } });
export const addSporeUserImageFailure = (error) => ({ type: ADD_SPOREUSER_IMAGE.FAILURE, payload: { error } });

// Remove image
export const REMOVE_SPOREUSER_IMAGE = createRequestTypes("REMOVE_SPOREUSER_IMAGE");

export const removeSporeUserImageRequest = (id) => ({ type: REMOVE_SPOREUSER_IMAGE.REQUEST, payload: { id } });
export const removeSporeUserImageSuccess = (sporeuser) => ({ type: REMOVE_SPOREUSER_IMAGE.SUCCESS, payload: { sporeuser } });
export const removeSporeUserImageFailure = (error) => ({ type: REMOVE_SPOREUSER_IMAGE.FAILURE, payload: { error } });

// Intended to force update of perks of user
export const FETCH_SPOREUSER_PERKS = createRequestTypes("FETCH_SPOREUSER_PERKS");

export const fetchSporeUserPerks = (sporeuser) => ({ type: FETCH_SPOREUSER_PERKS.REQUEST, payload: { sporeuser } });
export const fetchSporeUserPerksSuccess = (perks) => ({ type: FETCH_SPOREUSER_PERKS.SUCCESS, payload: { perks } });

// Clears
export const CLEAR_SPOREUSER_STATUS = createRequestTypes("CLEAR_SPOREUSER_STATUS");

export const clearSporeUserStatusRequest = () => ({ type: CLEAR_SPOREUSER_STATUS.REQUEST });
export const clearSporeUserStatusSuccess = () => ({ type: CLEAR_SPOREUSER_STATUS.SUCCESS });